import React from "react";
import { TurnrModalContent, TurnrModalHeader } from "~/components/modals/TurnrModal";
import OneClickOptionsWrapper, { OneClickTextOption } from "../../OneClickOptions";
import ProductItem from "~/components/productItem/ProductItem";
import { getExchangeBaseProduct, getVariantsWithInventory } from "~/cores/exchangeToProductsCore.js";

export default function ComplaintStepExchangeTo({ appProps, complaintStepperProps }) {
    const { getLocaleText } = appProps;

    const { onBack, onModalClose, product, productExchangeServiceData, onSaveExchangeTo } = complaintStepperProps;
    const exchangeBaseProduct = getExchangeBaseProduct(productExchangeServiceData);

    return (
        <>
            <TurnrModalHeader onBack={onBack} Close={onModalClose} title={getLocaleText("complaint-compensation-step-title")} />
            <TurnrModalContent>
                <OneClickOptionsWrapper>
                    <OneClickTextOption dataTestId={`complaint-exchange-to-no-thanks`} onClick={() => onSaveExchangeTo()}>
                        {getLocaleText("no-thanks-prefer-refund")}
                    </OneClickTextOption>
                    {getVariantsWithInventory(productExchangeServiceData)?.map((variant) => {
                        const variantId = variant?.id;
                        return (
                            <ProductItem
                                key={variantId}
                                dataTestId={`complaint-exchange-to-${variantId}`}
                                appProps={appProps}
                                // Spread order matters: login `product` provides session-only fields (purchasePrice, sessionItemId);
                                // `exchangeBaseProduct` overrides display fields with the clean parent productName
                                // (login's productName arrives composed with the variant color, e.g. "Forever Blazer Grey");
                                // `variant` overlays variant-specific fields (id, properties, imageSrc).
                                product={{ ...product, ...exchangeBaseProduct, ...variant }}
                                tight={true}
                                smallImage={true}
                                onClick={() => onSaveExchangeTo(variantId)}
                            />
                        );
                    })}
                </OneClickOptionsWrapper>
            </TurnrModalContent>
        </>
    );
}
